import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export function PlatformGuard() {
  const { isPlatformAdmin } = useAuth();

  if (!isPlatformAdmin) {
    return <Navigate to="/platform/login" replace />;
  }

  return <Outlet />;
}
